import styled from '@emotion/styled';
import {motion} from 'framer-motion';
import {IDateProps} from './DateComponent';

export const Container = styled(motion.div)<
  Pick<IDateProps, 'backgroundColor'>
>`
  display: flex;
  padding: 1.33em 1.5em;
  gap: 1.5em;
  background-color: ${({backgroundColor}) => backgroundColor};
  border-radius: 6px;
  justify-content: flex-start;
  flex-direction: row;
  width: fit-content;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Header = styled.h5<Pick<IDateProps, 'textColor'>>`
  font-size: rem;
  line-height: 130%;
  color: ${({textColor}) => textColor};
  opacity: 0.4;
  font-weight: 400;
`;

export const Value = styled.p<Pick<IDateProps, 'textColor'>>`
  font-size: 1.3125em;
  line-height: 130%;
  color: ${({textColor}) => textColor};
`;

export const Divider = styled.div<Pick<IDateProps, 'textColor'>>`
  border-left: 1px solid ${({textColor}) => textColor};
  opacity: 0.1;
`;
